module.exports = __webpack_public_path__ + "img/future-house.a0a0747b.jpg";